import { Component, OnInit } from '@angular/core';
import { ListaService } from '../../_services/lista.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../_services/_nav.service';
import { Location } from '@angular/common';
import { ActivatedRoute, Params } from '@angular/router';
import { PoliticasCredito } from '../../_models/politicas-credito';
import { PoliticasCreditoService } from '../../_services/politicas-credito.service';
import { NivelesService } from '../../_services/niveles.service';
import { Nivel } from '../../_models/nivel';
import {SegmentoNivelEndeudamientoService} from '../../_services/segmento-nivel-endeudamiento.service';

@Component( {
  selector: 'app-politicas-credito-editar',
  templateUrl: 'politicas-credito-editar.component.html'
} )

export class PoliticasCreditoEditarComponent implements OnInit {

  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  politica: PoliticasCredito;
  lisPoliticas: PoliticasCredito[] = [];
  tabSeleccionado = 'INFO';
  listadoNiveles: SelectItem[] = [];
  formulario: FormGroup;
  submitted = false;
  aleRequerido = false;

  constructor( private lisServicio: ListaService,
               private nav: NavService,
               private location: Location,
               private politicasCreditoService: PoliticasCreditoService,
               private conServicio: ConfirmationService,
               private route: ActivatedRoute,
               private nivelesService: NivelesService,
               private fb: FormBuilder,
               private segmentoNivelEndeudamientoService: SegmentoNivelEndeudamientoService) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.politicasCreditoService.obtenerPorId( params[ 'id' ] ).subscribe( politica => {
          this.politica = politica;
          this.carServicios();
        } );
      } else {
        this.politicasCreditoService.listadoPoliticas().subscribe( politicas => {
          this.lisPoliticas = politicas;
          this.carServicios();
        } );
      }
    } );
  }


  carServicios() {
    this.formulario = this.fb.group( {
      idPoliticaCredito: [ this.politica ? this.politica.idPoliticaCredito : null ],
      idNivel: [ this.politica ? this.politica.idNivel : null, (this.politica && this.politica.indicadorRequiereAprobacion) ? [ Validators.required ] : [] ],
      codigo: [ this.politica ? this.politica.codigo : null, [ Validators.required, Validators.maxLength( 10 ) ] ],
      nombre: [ this.politica ? this.politica.nombre : null, [ Validators.required, Validators.maxLength( 50 ) ] ],
      descripcion: [ this.politica ? this.politica.descripcion : null, [ Validators.required, Validators.maxLength( 500 ) ] ],
      respuesta: [ this.politica ? this.politica.respuesta : null, [ Validators.required, Validators.maxLength( 500 ) ] ],
      indicadorAlerta: [ this.politica ? this.politica.indicadorAlerta : null ],
      indicadorAlertaDescarta: [ this.politica ? (this.politica.indicadorDescarta ? true : false) : null, [ Validators.required ] ],
      indicadorDescarta: [ this.politica ? this.politica.indicadorDescarta : null ],
      indicadorOficina: [ this.politica ? this.politica.indicadorOficina : null ],
      indicadorSegmento: [ this.politica ? this.politica.indicadorSegmento : null ],
      indicadorRequiereAprobacion: [ this.politica ? this.politica.indicadorRequiereAprobacion : null ],
      indicadorDeudorSolidario: [ this.politica ? this.politica.indicadorDeudorSolidario : null ],
      indicadorTitular: [ this.politica ? this.politica.indicadorTitular : null ],
      indicadorCodeudor: [ this.politica ? this.politica.indicadorCodeudor : null ],
      indicadorHabilitado: [ this.politica ? this.politica.indicadorHabilitado : true ],
      auditoriaUsuario: [ this.politica ? this.politica.auditoriaUsuario : null ],
      auditoriaFecha: [ this.politica ? this.politica.auditoriaFecha : null ],
    } );

    this.nivelesService.listado().subscribe( res => {
      this.listadoNiveles = [];
      res.map( ( x: Nivel ) => {
        if ( x.indicadorAprueba ) {
          this.listadoNiveles.push( { label: x.nombre, value: x.idNivel } );
        }
      } );
      this.carInformacionInicial = false;
    } );


  }

  onSubmit() {
    this.submitted = true;
    this.validarAlerta();
    if ( !this.codExiste && this.formulario.valid && !this.aleRequerido ) {
      this.guardando = true;
      this.guardarPolitca();
    }
  }

  guardarPolitca() {
    const politica = this.formulario.value;
    politica.indicadorAlerta = !politica.indicadorAlertaDescarta;
    politica.indicadorDescarta = politica.indicadorAlertaDescarta;
    if ( politica.idPoliticaCredito) {
      this.politicasCreditoService.actualizar( politica ).subscribe( rta => {
        this.politica = politica;
        this.nav.setMesage( 2 );
        this.guardando = false;
        if ( !this.politica.indicadorHabilitado) {
          this.segmentoNivelEndeudamientoService.politicaCredito(this.politica.idPoliticaCredito)
            .subscribe();
        }
        if ( this.politica.indicadorAlerta ) {
          this.location.back();
        } else if ( this.politica.indicadorOficina ) {
          this.tabSeleccionado = 'OFICINA';
        } else {
          this.tabSeleccionado = 'SEGMENTO';
        }
      }, error => {
        this.nav.setMesage( 3 );
        this.guardando = false;
      } );
    } else {
      this.politicasCreditoService.crear( politica ).subscribe( rta => {
        politica.idPoliticaCredito = rta.idPoliticaCredito;
        this.politica = politica;
        this.f.idPoliticaCredito.setValue( rta.idPoliticaCredito );
        this.nav.setMesage( 1 );
        this.guardando = false;
        if ( this.politica.indicadorAlerta ) {
          this.location.back();
        } else if ( this.politica.indicadorOficina ) {
          this.tabSeleccionado = 'OFICINA';
        } else {
          this.tabSeleccionado = 'SEGMENTO';
        }
      }, error => {
        this.nav.setMesage( 3 );
        this.guardando = false;
      } );
    }
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.nav.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.nav.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'politica-editar',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }

  validarCodigo() {
    this.codExiste = this.lisPoliticas.find( x => x.codigo === this.f.codigo.value ) ? true : false;
  }

  get f() {
    return this.formulario.controls;
  }

  abrirAcordeon( evento: any ) {
    let indice = evento.index;

    if ( !this.politica.indicadorOficina && indice >= 1 ) {
      indice++;
    }


    switch ( evento.index ) {
      case 0: {
        this.tabSeleccionado = 'INFO';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'OFICINA';
        break;
      }
      case 2: {
        this.tabSeleccionado = 'SEGMENTO';
        break;
      }
      default: {
        break;
      }
    }
  }

  cambiarTabSeleccionado( tab: string ) {
    this.tabSeleccionado = tab;
  }

  alerta() {
    this.f.idNivel.clearValidators();
    if ( !this.f.indicadorAlertaDescarta.value ) {
      this.f.indicadorSegmento.setValue( false );
      this.f.indicadorOficina.setValue( false );
    } else {
      this.f.indicadorRequiereAprobacion.setValue( false );
      this.f.idNivel.setValidators( [] );
      this.f.idNivel.setValue( null );
    }
  }

  cambiarRequiereAprobacion() {
    this.f.idNivel.clearValidators();
    if ( this.f.indicadorRequiereAprobacion.value ) {
      this.f.idNivel.setValidators( [ Validators.required ] );
    } else {
      this.f.idNivel.setValue( null );
      this.f.idNivel.setValidators( [] );
    }
  }

  validarAlerta() {
    this.aleRequerido = (!this.f.indicadorAlertaDescarta.value || this.f.indicadorOficina.value || this.f.indicadorSegmento.value) ? false : true;
  }

}
